var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text"},[_vm._v("\n\tNew "+_vm._s(_vm.contactType)+" added to the "),_c('MarketComponent',{attrs:{"notification":_vm.notification}}),_vm._v(" Real Estate Rolodex by "),_c('UserComponent',{attrs:{"notification":_vm.notification}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }